import { FC } from 'react';

import { useDashboardFeedback } from '@phoenix/team-m/dashboard/frontend/shared/use-dashboard-feedback';
import { ServiceReminderPopUp } from '@phoenix/team-m/dashboard/frontend/shared/notifications/service-reminder-pop-up';
import { useSectionsOrder } from '@phoenix/team-m/dashboard/frontend/shared/use-sections-order';
import { useCustomerSupportLink } from '@phoenix/team-m/my-tool-shed/frontend/shared/use-customer-support-link';

import { BannerDashboard as Banner } from '../banner/banner-dashboard';
import { FeedbackBanner } from '../feedback/feedback-banner';
import { FromTheShopSection } from '../from-the-shop/from-the-shop-section';
import { GuidesSection } from '../guides/guides-section';
import { InterestingForYouSection } from '../interesting-for-you/interesting-for-you-section';
import { MainDealerSection } from '../main-dealer/main-dealer-section';
import { DashboardHero } from './dashboard-hero/dashboard-hero';
import { CustomerSupportSection } from './customer-support-section';
import { WarrantyExtensionSection } from '../warranty-extension/warranty-extension-section';
import { MyBenefitsBanner } from '../banner/my-benefits-banner';

import styles from './dashboard-overview.module.scss';

export const DashboardOverview: FC = () => {
  useDashboardFeedback({ supportLink: useCustomerSupportLink() });
  const { variationName, sections } = useSectionsOrder();

  return (
    <>
      <DashboardHero />
      <div className={styles.dashboardSections} data-testid={variationName}>
        {sections.map((section, i) => {
          const Component = {
            'promotional-banner': Banner,
            'from-the-shop': FromTheShopSection,
            guides: GuidesSection,
            'interesting-for-you': InterestingForYouSection,
            'my-dealers': MainDealerSection,
            'customer-support': CustomerSupportSection,
            'feedback-banner': FeedbackBanner,
            'warranty-extension': WarrantyExtensionSection,
            'my-benefits': MyBenefitsBanner,
          }[section];
          return Component && <Component key={section} isFirstSection={i === 0} isLastSection={i === sections.length - 1} />;
        })}
      </div>
      <ServiceReminderPopUp />
    </>
  );
};
